"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const toolkit_1 = require("@reduxjs/toolkit");
const react_i18next_1 = require("react-i18next");
const primaryButton_1 = __importDefault(require("../../components/primaryButton/primaryButton"));
const utils_1 = require("../../utils/utils");
const banks_1 = __importDefault(require("../../utils/banks"));
const imageInput_1 = __importDefault(require("../../components/documentUpload/imageInput/imageInput"));
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const store_1 = require("../../store");
const text_1 = __importStar(require("../../components/text/text"));
const input_1 = __importStar(require("../../components/input/input"));
const screenConstants_1 = require("../../constants/screenConstants");
const partnerSlice_1 = require("./partnerSlice");
const navContainer_1 = __importDefault(require("../../components/navContainer/navContainer"));
const analytics_1 = require("../../utils/analytics/analytics");
const useGetUpdates_1 = __importDefault(require("../../hooks/useGetUpdates"));
const authSlice_1 = require("../auth/authSlice");
const PartnerBankAccountInformation = ({ route }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    (0, useGetUpdates_1.default)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const navigation = (0, useAppNavigation_1.default)();
    const { params } = route;
    // User info
    const [bankName, setBankName] = (0, react_1.useState)('0');
    const [bankAccountName, setBankAccountName] = (0, react_1.useState)('');
    const [bankAccountNumber, setBankAccountNumber] = (0, react_1.useState)('');
    const [bvn, setBvn] = (0, react_1.useState)('');
    const [idDocument, setIdDocument] = (0, react_1.useState)({});
    const [idDocumentName, setIdDocumentName] = (0, react_1.useState)('');
    const [errors, setErrors] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const localPartnerName = params.partner !== undefined && params.partner !== '' ? params.partner.replace(/_+/, ' ') : '';
    // VALIDATE FINANCIAL BANK ACCOUNT FORM DATA - SAVE
    const submitForm = async () => {
        setIsLoading(true);
        let payload = {
            bank_name: bankName,
            bank_account_name: bankAccountName.toString(),
            bank_account_number: bankAccountNumber.toString(),
            bvn: bvn.toString(),
        };
        const formDataPayload = new FormData();
        Object.entries(payload).forEach((entry) => {
            formDataPayload.append(entry[0], entry[1]);
        });
        if (typeof idDocument === 'string') {
            const file = await fetch(idDocument).then((r) => r.blob());
            payload = { ...payload, identity_document: file };
            // @ts-ignore
            formDataPayload.append('identity_document', file, idDocumentName);
        }
        const result = await dispatch(params.partner !== undefined && params.partner !== ''
            ? (0, partnerSlice_1.submitPartnershipFinancialInformation)(formDataPayload)
            : (0, partnerSlice_1.submitJumiaFinancialInformation)(formDataPayload));
        logEventWithExtraProperties('api_call', {
            name: 'add_partner_bank_account_information',
            status: 'submitted',
            location: 'screen_PartnerBankAccountInformation',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            dispatch((0, authSlice_1.savePartnerName)(localPartnerName));
            logEventWithExtraProperties('api_call', {
                name: 'add_partner_bank_account_information',
                status: 'success',
                location: 'screen_PartnerBankAccountInformation',
            });
            setIsLoading(false);
            navigation.navigate(screenConstants_1.PARTNER_CONNECT_BANK);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'add_partner_bank_account_information',
                status: 'fail',
                location: 'screen_PartnerBankAccountInformation',
            });
            setErrors(result.payload);
            setIsLoading(false);
        }
    };
    return (react_1.default.createElement(navContainer_1.default, { isLoading: isLoading, errors: errors, footer: react_1.default.createElement(primaryButton_1.default, { title: "Submit", onPress: submitForm, eventName: "partnership_complete_loan_application" }), childrenTitle: `   Partnership with ${params.partner !== undefined && params.partner !== '' ? localPartnerName : `Jumia`}` },
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_NUMBER, isBVN: true, label: "BVN Number", placeholder: "BVN", setValue: setBvn, value: bvn, error: (0, utils_1.getError)('bvn', errors) }),
        react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, biggerSubtitle: true }, t('jumia.bankAccountInformation.main_bank_account')),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "Choose Bank", choices: banks_1.default, value: bankName, setValue: setBankName, error: (0, utils_1.getError)('bank_name', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_NUMBER, label: "Account number", placeholder: "Account number", setValue: setBankAccountNumber, error: (0, utils_1.getError)('bank_account_number', errors), value: bankAccountNumber }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_TEXT, label: "Bank Account Name", placeholder: "Bank Account Name", setValue: setBankAccountName, error: (0, utils_1.getError)('bank_account_name', errors), value: bankAccountName }),
        react_1.default.createElement(imageInput_1.default, { toUploadTitle: "UPLOAD ID DOCUMENT", image: idDocument, setImage: setIdDocument, setImageName: setIdDocumentName, error: (0, utils_1.getError)('identity_document', errors) })));
};
exports.default = PartnerBankAccountInformation;
